<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input-autocomplete
                    :repository="repositories.parametrizacao.procedimentoCirurgico"
                    :request-query-string-params="{ not_id: procedimentosCirurgicosPrestadoresIds }"
                    :search-fields="fields.grupoProcedimentoCirurgico"
                    :validations="validations.grupoProcedimentoCirurgico"
                    label="Grupo de procedimento cirúrgico / Procedimento cirúrgico"
                    :text-field="i => i.codigo ? `${this.formatProcedimento(i.codigo)} - ${i.nome}` : i.nome"
                    uppercase
                    v-model="model.grupoProcedimentoCirurgico"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click="$refs.Form.validate(add)"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, object, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                grupoProcedimentoCirurgico: { required: true },
            }
        },
        procedimentosCirurgicosPrestadoresIds() {

            return this.prestador.procedimentosCirurgicos.map(pc => pc.id)
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('regulacao.parametrizacao')
        }
    },
    data: () => ({
        fields: {
            grupoProcedimentoCirurgico: [
                { key: 'item.codigo', searchable: true },
                { key: 'item.nome', searchable: true },
            ],
        },
        model: {
            grupoProcedimentoCirurgico: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        add() {

            if (this.model.grupoProcedimentoCirurgico.origem === 'procedimento') {

                this.prestador.procedimentosCirurgicos.push(this.prepareData(this.model.grupoProcedimentoCirurgico))

                this.resetForm()
            }
            else {

                this.getProcedimentosCirurgicos().then(procedimentosCirurgicos => {

                    procedimentosCirurgicos.filter(pc => !this.procedimentosCirurgicosPrestadoresIds.includes(pc.id))
                        .forEach(procedimentoCirurgico => this.prestador.procedimentosCirurgicos
                            .push(this.prepareData(procedimentoCirurgico)))

                    this.resetForm()
                })
            }
        },
        async getProcedimentosCirurgicos() {

            let procedimentosCirurgicos = [];

            this.setLoading()

            try {

                procedimentosCirurgicos = (await this.repositories.parametrizacao.list({
                    listar: 'procedimentos-cirurgicos',
                    grupo_id: this.model.grupoProcedimentoCirurgico.id
                })).data
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }

            return procedimentosCirurgicos
        },
        prepareData(procedimentoCirurgico) {

            procedimentoCirurgico = this.clone(procedimentoCirurgico)
            procedimentoCirurgico.ativo = true

            return procedimentoCirurgico

        },
        resetForm() {

            this.model.grupoProcedimentoCirurgico = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        }
    },
    mixins: [repository, error, object, formats],
    props: {
        prestador: { type: Object, required: true },
    },
}
</script>